import UndoRedoHotkeys from '../components/UndoRedoHotkeys';
import DiagramCanvas from './diagram.canvas';
import { DiagramStoreProvider } from '../store/store.provider';
import { useLoaderData } from 'react-router-dom';
import { NodeModel } from '@diagram/model/node.model';
import { EdgeModel } from '@diagram/model/edge.model';
import { DrillDownModel } from '@diagram/model/drilldown.model';
import { DiagramModel } from '@diagram/model/diagram.model';
import { ElementById } from '@diagram/store/store.types';
import Layout from '../../../components/Sidebar/Layout';
import DnDProvider from '../../../context/DnDProvider';

// import Layout from '../../../components/Sidebar/Layout';
// import DnDProvider from '../../../context/DnDProvider';

const Diagram = () => {
  const { nodes, edges, drilldowns, diagram, rfNodes, rfEdges } =
    useLoaderData() as {
      nodes: ElementById<NodeModel>;
      edges: ElementById<EdgeModel>;
      drilldowns: ElementById<DrillDownModel>;
      diagram: DiagramModel;
      rfNodes: NodeModel[];
      rfEdges: EdgeModel[];
    };

  return (
    <DiagramStoreProvider
      nodesById={nodes}
      rfNodes={rfNodes}
      rfEdges={rfEdges}
      edgesById={edges}
      drilldowns={drilldowns}
      data={diagram}
    >
      <UndoRedoHotkeys />
      <DnDProvider>
        <Layout>
          <DiagramCanvas />
        </Layout>
      </DnDProvider>
    </DiagramStoreProvider>
  );
};
export default Diagram;
